import { render, staticRenderFns } from "./ListPromotions.vue?vue&type=template&id=f0fa3700&"
import script from "./ListPromotions.vue?vue&type=script&lang=js&"
export * from "./ListPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports